import Rails from '@rails/ujs';

// start() throws if a second pack on the same page already started it.
if (!window._rails_loaded) Rails.start();
